module.exports = __webpack_public_path__ + "static/media/m_beard_medium_round__oval_shadow.d3bf5fb0.png";